import { render } from "./App.vue?vue&type=template&id=73cadd40"
const script = {}

import exportComponent from "C:\\Users\\USER\\Projects\\qrcode_llf\\qrcode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__